import React, { useMemo, useState, useEffect } from "react";
import { GoPrimitiveDot } from "react-icons/go";
import { FaMapMarkerAlt } from "react-icons/fa";
import { CheckBoxInput } from "../../../../components/common/Buttons";
import moment from "moment";
import TableComment from "./TableComment";
import SmsIcon from "../../../../../assets/images/sms.svg";
import attachmentIcon from "../../../../../assets/images/attachment.svg";
import ShipmentStoreSvg from "../../../../../assets/images/shipment/shipment_store.svg";
import { AiOutlineNumber } from "react-icons/ai";
import { SerialNumberModal } from "../../../../components/common/SerialNumberModal";
import { returnEuroString, toFixedNumber } from "../../../../helpers/Utils";
import ClientInfoComponent from "../../../../components/Repetitive_components/clientInfoComponent";
import CourierLinksComponent from "../../../../components/Repetitive_components/courierLinksComponent";
import ShipmentComponentIndex from "./ShipmentComponentIndex";
import OrderRows from "./order_row_index/OrderRows";
import { have_product_reference } from "../../../../helpers/OrdersFunctionsGlobal";
import { removeDuplicates } from "../../../../helpers/array";
import { IconRollbackPurple } from "../../../../components/Layout/Icons";
import OrderRowReference from "../features/order_rows/OrderRowReference";
import { Tooltip } from "antd";
import { FaArrowUp, FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useSelector } from "react-redux";

function TableColumnAO({
  id,
  item,
  index,
  checkBoxIncludes,
  onEdit,
  updateSerialNumber,
  order_row_type,
  bulk_shipments,
  handleCheck,
  handleSelected,
  additionalOptions,
  reload_for_bulk_shipments,
  supp_date,
  disabled,
  pickedSupplierId,
}) {
  const [SNumber, setSNumber] = useState(false);
  const [visible, setVisible] = useState(false);

  // console.count('order item')

  const commentOverWeight = useMemo(
    () =>
      !!item.comments.find(
        (comment) => comment.user_title == "[AUTOSYS] OVERWEIGHT"
      ),
    [item.comments.length]
  );

  const commentMemo = useMemo(() => {
    const commentItems = item.comments.sort(
      (a, b) => new Date(b.created_at) + new Date(a.created_at)
    );
    return (
      <>
        {checkBoxIncludes("KA komentarai") && (
          <TableComment comments={commentItems} type="comment_ka" />
        )}
        {checkBoxIncludes("Vadyba") && (
          <TableComment comments={commentItems} type="comment_management" />
        )}
        {checkBoxIncludes("Logistika") && (
          <TableComment comments={commentItems} type="comment_logistic" />
        )}
      </>
    );
  }, [
    item.comments.length,
    checkBoxIncludes("Logistika"),
    checkBoxIncludes("Vadyba"),
    checkBoxIncludes("KA komentarai"),
  ]);

  const returns_order_rows = useMemo(() => {
    return item.order_rows
      .filter(
        ({ returns_count }) =>
          typeof returns_count == "number" && returns_count > 0
      )
      .map((r) => ({
        id: r.id,
        quantity: r.returns_count,
        product_name: r.product_name,
        product_reference: r.product_reference,
        parent_id: r.parent_id,
        unit_price_tax_incl: r.unit_price_tax_incl,
      }));
  }, [item.order_rows]);

  return (
    <tr
      className={`align-middle tableColumn ${!!returns_order_rows.length ? "row-color-purple" : ""
        }`}
      style={{
        borderLeft: item.urgent ? "4px solid red" : "none",
      }}
    >
      <td className="align-middle">
        <div className="d-flex">
          <CheckBoxInput
            type="checkbox"
            color="#f7951e"
            checked={handleSelected("order", id)}
            onChange={() => handleCheck("order", { order_id: id })}
          />
        </div>
      </td>
      {checkBoxIncludes("Eksp") && (
        <td className="align-middle">
          <GoPrimitiveDot
            style={item.checked ? { color: "green" } : { color: "red" }}
          />
        </td>
      )}
      <td className="align-middle">{item.order_shop?.title}</td>
      {checkBoxIncludes("Užsakymo data") && (
        <td className="align-middle">
          <span className="date-field">
            {moment(item.order_date).format("YYYY MM DD")}
          </span>
          <br />
          <span className="date-field">
            {moment(item.order_date).format("HH:mm")}
          </span>
        </td>
      )}
      {checkBoxIncludes("Order numeris") && (
        <td
          className="align-middle"
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
        >
          <div
            className="cursor-pointer"
            onMouseUp={(e) => {
              if (e.button == 0) {
                onEdit(item.id_order, id);
              } else {
                window.open(`/orders/${id}`, "_blank");
                window.focus();
              }
            }}
          >
            {item.id_order}
          </div>
        </td>
      )}
      {checkBoxIncludes("Klientas") && (
        <td className="align-middle">
          <ClientInfoComponent
            shipping_address={item.shipping_address}
            client={item.customer}
            customer={item.customer}
            note_from_client={item.shipping_address?.remark || item.remark}
            commentOverWeight={commentOverWeight}
            order_shop={item.order_shop}
            item={item}
          />
        </td>
      )}
      {checkBoxIncludes("Mokėtojas") && (
        <td className="align-middle">
          <ClientInfoComponent
            shipping_address={item.shipping_address}
            client={item.customer}
            customer={item.customer}
            note_from_client={item.shipping_address?.remark || item.remark}
            commentOverWeight={commentOverWeight}
            order_shop={item.order_shop}
          />
        </td>
      )}
      {checkBoxIncludes("Gabenimo adresas") && (
        <td className="align-middle">
          <span className="font-weight-bold">
            {item.shipping_address.firstname !== null &&
              item.shipping_address.firstname}{" "}
            {item.shipping_address.lastname !== null &&
              item.shipping_address.lastname}
          </span>
          <br />
          <span style={{ fontSize: "0.6rem" }}>
            {item.shipping_address?.country?.en_name &&
              `${item.shipping_address.country.en_name}, `}
            {item.shipping_address.city + " " + item.shipping_address.street}
            <br />
            {item.shipping_address.phone}
          </span>
          <br />
          <span style={{ fontSize: "0.6rem" }}>
            {item.shipping_address.other}
          </span>
        </td>
      )}
      {checkBoxIncludes("Prekes") && (
        <td className="align-middle p-0" style={{ width: 400 }}>
          {returns_order_rows.map((return_order_row) => (
            <div
              key={return_order_row.id}
              className="d-flex flex-column text-sm my-2"
            >
              <span className="d-flex flex-column flex-wrap">
                <div className="d-flex align-items-center justify-content-between pl-1">
                  <IconRollbackPurple />
                  <div
                    className="pr-1 text-sm pl-2"
                    style={{
                      width: 230,
                    }}
                  >
                    <div
                      style={{
                        maxWidth: 200,
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                      }}
                    >
                      <OrderRowReference order_row={return_order_row} />
                    </div>
                  </div>
                  <div
                    className="px-1  text-right"
                    style={{
                      width: 30,
                    }}
                  >
                    {parseInt(return_order_row.quantity)}
                  </div>
                  <div
                    className="text-right"
                    style={{
                      width: 60,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {returnEuroString(return_order_row.unit_price_tax_incl)}
                  </div>
                </div>
              </span>
            </div>
          ))}
          <OrderRows
            order_id={item.id}
            order_shop_id={item.order_shop_id}
            order_invoices={item.order_invoices}
            order_rows={item.order_rows}
            order_cart_rules={item.order_cart_rules}
            order={item}
            order_row_type={order_row_type}
            bulk_shipments={bulk_shipments}
            handleSelected={handleSelected}
            handleCheck={handleCheck}
            additionalOptions={additionalOptions}
            reload_for_bulk_shipments={reload_for_bulk_shipments}
            supp_date={supp_date}
            pickedSupplierId={pickedSupplierId}
          />
        </td>
      )}
      {/* Nordrent: hidden "Residues" (product suppliers) column */}
      {/* {checkBoxIncludes("Likučiai") && (
        <Balances
          order_rows={item.order_rows}
          disabled={disabled}
          pickedSupplierId={pickedSupplierId}
        />
      )} */}
      {checkBoxIncludes("Mokėjimo būdas") && (
        <td className="align-middle">{item.payment}</td>
      )}
      {checkBoxIncludes("Pristatymas") && (
        <td className="align-middle">
          <CourierLinksComponent key={item.shipments} shipments={item.shipments} />
          <div>
            {item.carrier.module_name == "upickupatstore" &&
              !item.carrier?.pickup_address_id ? (
              <span>
                Pickup at the store:
                <div className="d-flex py-1 px-2">
                  <div className="d-flex justify-content-center align-items-center mr-1">
                    <FaMapMarkerAlt className="text-orange" />
                  </div>
                  <div className="text-orange">
                    <p className="mb-0">{"Veiverių g. 171, Kaunas"}</p>
                  </div>
                </div>
              </span>
            ) : (
              item.carrier.name
            )}
          </div>
        </td>
      )}
      {checkBoxIncludes("Statusas") && (
        <td className="align-middle">{item.status?.title}</td>
      )}
      {/* Nordrent: hidden comment columns (KA / Manager / Logistic) */}
      {/* {commentMemo} */}
      {checkBoxIncludes("Suma") && (
        <td className="align-middle">
          {toFixedNumber(item.total_price)}
          {item.is_without_vat && (
            <div className="badge badge-pill badge-danger text-xs font-semi-bold">
              {"Excl. VAT"}
            </div>
          )}
        </td>
      )}
      <td className="align-middle" style={{ width: "50px" }}>
        {item.has_documents && (
          <button className="btn btn-sm " style={{ background: "#f29302" }}>
            <img
              style={{ color: "white" }}
              width="11.12"
              height="11.12"
              src={attachmentIcon}
            />
          </button>
        )}
        {item.has_sms && (
          <button className="btn btn-sm " style={{ background: "red" }}>
            <img
              style={{ color: "white" }}
              width="11.12"
              height="11.12"
              src={SmsIcon}
            />
          </button>
        )}
        {SNumber ? (
          <div>
            <SerialNumberModal
              id={item.id}
              SNumber={SNumber}
              options={item.order_rows}
              onOk={() => setSNumber((prevState) => !prevState)}
              onCancel={() => setSNumber((prevState) => !prevState)}
              updateSerialNumber={updateSerialNumber}
            />
          </div>
        ) : (
          <button
            className={`btn btn-sm ${sfColorButton(item.order_rows)}`}
            onClick={() => setSNumber((prevState) => !prevState)}
          >
            <AiOutlineNumber color="white" />
          </button>
        )}
      </td>
    </tr>
  );
}

export default TableColumnAO;

const sfColorButton = (order_rows) => {
  return order_rows.some(
    (item) => item.required_serial_number && !item.serial_number
  )
    ? "bg-warning"
    : order_rows.some((item) => item.required_serial_number)
      ? "bg-success"
      : "bg-danger";
};

const Balances = ({ order_rows, disabled, pickedSupplierId }) => {
  const [showAllSuppliers, setShowAllSuppliers] = useState({});
  const user_suppliers = useSelector(
    (state) => state.filters.orders.user_suppliers
  );

  const handleRowClick = (supplier) => {
    console.log("Supplier details:", supplier);
  };

  const isSupplierHighlighted = (supplierId, supplyings) => {
    if (supplierId === 22) {
      return false;
    }
    return (
      (user_suppliers?.includes(supplierId) ||
        supplierId === pickedSupplierId?.value) &&
      supplyings?.some((supply) => supply.supplier_id === supplierId)
    );
  };

  useEffect(() => {
    const expandedRows = {};
    order_rows?.forEach((order_row, orderIndex) => {
      const product_info = order_row.product_info;
      if (product_info && Array.isArray(product_info.product_suppliers)) {
        const product_suppliers = product_info.product_suppliers.filter(
          (supplier) => supplier.quantity !== null && supplier.quantity > 0
        );

        const mainSupplier = product_suppliers.find(
          (supplier) => supplier.supplier.id === product_info.main_supplier_id
        );

        if (
          mainSupplier &&
          isSupplierHighlighted(mainSupplier.supplier.id, order_row.supplyings)
        ) {
          expandedRows[orderIndex] = true;
        } else {
          const otherSuppliers = product_suppliers.filter(
            (supplier) => supplier.supplier.id !== product_info.main_supplier_id
          );

          if (
            otherSuppliers.some((supplier) =>
              isSupplierHighlighted(supplier.supplier.id, order_row.supplyings)
            )
          ) {
            expandedRows[orderIndex] = true;
          }
        }
      }
    });
    setShowAllSuppliers(expandedRows);
  }, [order_rows, user_suppliers, pickedSupplierId]);

  return (
    <td className="align-middle">
      <table className="table-hover table-sm">
        <tbody style={{ fontWeight: "400" }}>
          {order_rows.map((order_row, orderIndex) => {
            const product_info = order_row.product_info;
            if (
              !product_info ||
              !Array.isArray(product_info.product_suppliers)
            ) {
              return null;
            }

            const product_suppliers = product_info.product_suppliers
              .filter(
                (supplier) =>
                  supplier.quantity !== null && supplier.quantity > 0
              )
              .map((supplier) => ({
                ...supplier,
                product_reference: order_row.product_reference,
                main_supplier_id: product_info.main_supplier_id,
              }));

            const mainSupplier = product_suppliers.find(
              (supplier) => supplier.supplier.id === supplier.main_supplier_id
            );
            const otherSuppliers = product_suppliers.filter(
              (supplier) =>
                supplier.supplier.id !== supplier.main_supplier_id ||
                supplier !== mainSupplier
            );

            return (
              <React.Fragment key={`order_row_${orderIndex}`}>
                {mainSupplier ? (
                  <>
                    <Tooltip
                      key={`product_suppliers_${mainSupplier.id}`}
                      placement="top"
                      title={
                        disabled ? `Main Supplier` : mainSupplier.supplier.name
                      }
                    >
                      <tr onClick={() => handleRowClick(mainSupplier)}>
                        <td
                          style={{ whiteSpace: "nowrap" }}
                          className="residuesItem"
                        >
                          {mainSupplier.quantity} *{" "}
                        </td>
                        <td className="residuesItem">
                          {mainSupplier.supplying_incomes?.map(
                            (income, idx) => (
                              <div
                                key={idx}
                                className="d-flex flex-column residuesItem"
                              >
                                <div className="text-success d-flex align-items-center">
                                  {income?.quantity} <FaArrowUp size={6} />
                                </div>
                              </div>
                            )
                          )}
                        </td>
                        <td
                          style={{
                            backdropFilter: isSupplierHighlighted(
                              mainSupplier.supplier.id,
                              order_row.supplyings
                            )
                              ? "blur(5px)"
                              : "none",
                            backgroundColor: isSupplierHighlighted(
                              mainSupplier.supplier.id,
                              order_row.supplyings
                            )
                              ? "#FFE7125E"
                              : "inherit",
                          }}
                          className="residuesItem"
                        >
                          {mainSupplier.product_reference}
                        </td>
                        <td
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowAllSuppliers((prevState) => ({
                              ...prevState,
                              [orderIndex]: !prevState[orderIndex],
                            }));
                          }}
                          className="cursor-pointer"
                        >
                          {showAllSuppliers[orderIndex] ? (
                            <FaChevronUp color="#212529" />
                          ) : (
                            <FaChevronDown color="#212529" />
                          )}
                        </td>
                      </tr>
                    </Tooltip>
                    {showAllSuppliers[orderIndex] &&
                      otherSuppliers.map((supplier, idx) => (
                        <Tooltip
                          key={`product_suppliers_${supplier.id}_${idx}`}
                          placement="top"
                          title={
                            disabled
                              ? `Supplier ${idx + 1}`
                              : supplier.supplier.name
                          }
                        >
                          <tr onClick={() => handleRowClick(supplier)}>
                            <td
                              style={{ whiteSpace: "nowrap" }}
                              className="residuesItem"
                            >
                              {supplier.quantity} *{" "}
                            </td>
                            <td className="residuesItem">
                              {supplier.supplying_incomes?.map(
                                (income, idx) => (
                                  <div
                                    key={idx}
                                    className="d-flex flex-column residuesItem"
                                  >
                                    <div className="text-success d-flex align-items-center">
                                      {income?.quantity} <FaArrowUp size={6} />
                                    </div>
                                  </div>
                                )
                              )}
                            </td>
                            <td
                              style={{
                                backdropFilter: isSupplierHighlighted(
                                  supplier.supplier.id,
                                  order_row.supplyings
                                )
                                  ? "blur(5px)"
                                  : "none",
                                backgroundColor: isSupplierHighlighted(
                                  supplier.supplier.id,
                                  order_row.supplyings
                                )
                                  ? "#FFE7125E"
                                  : "inherit",
                              }}
                              className="residuesItem"
                            >
                              {supplier.product_reference}
                            </td>
                            <td></td>
                          </tr>
                        </Tooltip>
                      ))}
                  </>
                ) : (
                  product_suppliers.map((supplier, idx) => (
                    <Tooltip
                      key={`product_suppliers_${supplier.id}_${idx}`}
                      placement="top"
                      title={
                        disabled
                          ? `Supplier ${idx + 1}`
                          : supplier.supplier.name
                      }
                    >
                      <tr
                        onClick={() => handleRowClick(supplier)}
                        className="cursor-pointer"
                      >
                        <td
                          style={{ whiteSpace: "nowrap" }}
                          className="residuesItem"
                        >
                          {supplier.quantity} *{" "}
                        </td>
                        <td className="residuesItem">
                          {supplier.supplying_incomes?.map((income, idx) => (
                            <div
                              key={idx}
                              className="d-flex flex-column residuesItem"
                            >
                              <div className="text-success d-flex align-items-center">
                                {income?.quantity} <FaArrowUp size={6} />
                              </div>
                            </div>
                          ))}
                        </td>
                        <td
                          style={{
                            backdropFilter: isSupplierHighlighted(
                              supplier.supplier.id,
                              order_row.supplyings
                            )
                              ? "blur(5px)"
                              : "none",
                            backgroundColor: isSupplierHighlighted(
                              supplier.supplier.id,
                              order_row.supplyings
                            )
                              ? "#FFE7125E"
                              : "inherit",
                          }}
                          className="residuesItem"
                        >
                          {supplier.product_reference}
                        </td>
                        <td></td>
                      </tr>
                    </Tooltip>
                  ))
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </td>
  );
};

const WrapperShipmentComponentIndex = ({ order, onClose }) => {
  const pickup_address_id = useMemo(() => {
    const availables_pickup_address_ids = removeDuplicates(
      order.order_rows
        .filter(
          ({ product_reference, selected, supplyings }) =>
            selected &&
            have_product_reference(product_reference) &&
            supplyings?.length > 0
        )
        .map(({ supplyings }) =>
          supplyings.map(
            (supplying) =>
              !supplying.used_at && supplying?.supplier?.pickup_address_id
          )
        )
        .flat()
    ).filter((value) => !!value);
    return availables_pickup_address_ids.at(-1) ?? null;
  }, [order.order_rows]);

  return (
    <ShipmentComponentIndex
      {...order}
      remark={order.shipping_address?.remark || order.remark}
      pickup_address_id={pickup_address_id}
      onClose={onClose}
    />
  );
};
